import "@/services/cookiebot"

import "@/modules/auth"
import "@/modules/wds"
import "@/modules/wcl"
import { trackUTMParams } from "@/modules/utm-params-tracking"

import initCookieBanner from "@/features/cookie-banner/init"

initCookieBanner()

trackUTMParams()
